export const getSuccessRes = (data, message = "Request successful") => {
  return {
    isSuccess: true,
    data: data || [],
    message: message,
  };
};

export const getErrorRes = (errorMessage, message = "Request failed") => {
  return {
    isSuccess: false,
    data: [],
    message:
      errorMessage || message,
  };
};

export const getWarningRes = (data, message = "Request completed with warnings") => {
  return {
    isSuccess: false,
    isWarning: true,
    data: data || [],
    message: message,
  };
};